import { ClientEnvironment, ClientEnvironmentName } from '~/core/types/environment';

export const environment: ClientEnvironment = {
	production: true,
	sentryDSN: undefined,
	environmentName: ClientEnvironmentName.PRODUCTION,
	clientId: 'default',
	clientUrl: 'https://mobile.staging.rea.ch',
	frontendUrl: 'https://dashboard.staging.rea.ch',
	apiBaseUrl: 'https://api.staging.rea.ch/',
	socialSignIn: {
		googleClientId: '106184129344-iphm6q5ab9tvvhq00gvmsb3f16kie2uo.apps.googleusercontent.com',
		appleClientId: 'ch.rea.app.signinweb',
		microsoftClientId: '3361613e-b173-498c-978f-20d709e6a56b',
		microsoftAuthority: 'common',
	},

	landingUrl: 'https://myreach.io',

	zapierAppLink:
		'https://zapier.com/developer/public-invite/166140/cf7febdc6b6b461a48abcb3492bdbb5e/',

	imageCdn: 'https://images.weserv.nl/',

	googleMapsApiKey: 'AIzaSyCF2aau-BaTRSU8CsUxXsErmQ10SgT0M2Y',

	handbookUrl: 'https://handbook.staging.rea.ch/',

	organizationDashboardUrl: 'https://manage.staging.rea.ch',
};
